//import { mapFields } from 'vee-validate';

export default {

	computed:{

	},
	methods:{


		vee(path){



			let flags = this.getFlags(path);
			return {
				classes: [this.errors.has(path) ? 'is-invalid' : '', !this.errors.has(path) && flags && flags.touched && flags.valid? 'is-valid' : ''],
				flags: flags,
				message: this.errors.first(path)
			}

		},

		getFlags(path){
			let p = path.split('.');
			let scope = null;
			let name = p[0];

			if (p.length > 1) {
				scope = p[0];
				name = p[1];
			}

			let flags;

			if (scope) {
				if (!this.fields['$' + scope]) {
					return false;
				}
				flags = this.fields['$' + scope][name];
			} else {
				flags = this.fields[name];

			}

			return flags;
		}
	}
}